export const FLEXIPAY_LOAN = {
  HOLDBACK_SUFFIX: 'of daily sales',
  LOAN_TERM_SUFFIX: 'months',
} as const;
